<template>
	<v-app :class="this.$route.path.indexOf('v1') > -1 ? 'layout1' : ''">
		<router-view></router-view>

		<v-dialog
			v-model="$store.state.loading"
			fullscreen
			overlay-color="transparent"
			transition="dialog-center-transition"
			content-class="mainloadingBar"
		>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-progress-circular indeterminate :size="100" :width="5" color="grey lighten-1"> </v-progress-circular>
				</v-layout>
			</v-container>
		</v-dialog>
	</v-app>
</template>

<script>
export default {
	name: 'App',
}
</script>
<style lang="scss">
@import 'Scss/main';
@import './public/css/global.scss';
html {
	overflow: hidden !important;
}
.hideClose {
	display: none;
}
.min-height800 {
	min-height: 800px;
	min-width: 1680px !important;
}
.layout1 {
	min-width: 1920px !important;
	// height: 100vh;
}
.v-application--wrap {
	height: 100vh !important;
	overflow: auto;
}
/* .noScrollbar {
	body::-webkit-scrollbar {
		width: 0 !important;
		display: none;
	}
}
.noScrollbar::-webkit-scrollbar {
	width: 0;
	display: none;
} */
</style>
